module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "slider-wrap"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.sliderLoading) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "slider",
    class: {
      'is-loading': _vm.sliderLoading
    },
    attrs: {
      "id": "slider"
    }
  }, [_vm._l((_vm.slides), function(slide) {
    return [_c('div', {
      class: ['slider-cell', {
        'is-video': slide.isVideo
      }]
    }, [(slide.isVideo) ? _c('iframe', {
      attrs: {
        "data-src": slide.source,
        "width": "640",
        "height": "360",
        "frameborder": "0",
        "title": "After Effects Animation"
      }
    }) : _c('img', {
      attrs: {
        "data-src": slide.source,
        "alt": slide.alt
      }
    })], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c802a73"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PortfolioGraphics.vue
// module id = 95
// module chunks = 0